/* This component is used for displaying About us form */
/* eslint-disable max-len */
/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import { Box, Modal, Grid, Tooltip } from '@mui/material';
import Draggable from 'react-draggable';
import { closeIconBlack, veolia_header } from '../../shared/assets/images';
import { defaultModalOptions, copyRightText, modifiedDate } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import './about.scss';

const AboutPopup = (props) => {
  const { visibleAbout, closeAboutPopup, translateObject } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [dbversion, setdbversion] = useState('');
  const [dbversion_date, setdbversion_date] = useState('');
  useEffect(() => {
    const db_details = JSON.parse(localStorage.getItem('db_version'));
    if (db_details) {
      setdbversion(db_details.db_version);
      setdbversion_date(db_details.DateOfChange.split(' ')[0]);
    }
  }, []);

  return (
    <Draggable handle='.split-header-grid' cancel='.no-drag'>
      <Modal
        hideBackdrop
        open={visibleAbout}
        onClose={closeAboutPopup}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        className="splitter-modal"
      >
        <Box className='about-box' display="flex">
          <Notification
            options={modalOption}
            handleClose={() => setModalOption(defaultModalOptions)}
          />
          <Grid container className='split-grid-container'>
            <Grid item xs={12} className='split-header-grid'>
              <div className='about-header-text ft rufusBld'>{translateObject('About')}</div>
              <div className='split-close-icon no-drag'>
                <Tooltip title="Close">
                  <img src={closeIconBlack} alt="close" onClick={closeAboutPopup} style={{ display: 'block' }} className="pointer" />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='split-body-container sansW4SeLig'>
              <Box sx={{ width: '100%', typography: 'body1' }} className='mixer-box-container'>
                <div className='logoCnt'>
                  <img className='logo' style={{ width: '40%' }} src={veolia_header} alt='logo' />
                </div>
                <div className="normal-font f-left mt-2">
                  <div className='about-title' style={{ marginTop: '-10px' }}>Winflows Design Simulator
                  </div>
                </div>
                <div className="about-content">
                  <ul>
                    <li>
                      <div className='left-text'>{translateObject('Program Date')}</div>
                      <span className='center-text'>:</span>
                      <span className='right-text'>{modifiedDate || '2023-10-13'}</span>
                    </li>
                    <li>
                      <div className='left-text'>{translateObject('Database Version')}</div>
                      <span className='center-text'>:</span>
                      <span className='right-text'>{dbversion}</span>
                    </li>
                    <li>
                      <div className='left-text'>{translateObject('Database Date')}</div>
                      <span className='center-text'>:</span>
                      <span className='right-text'>{dbversion_date}</span>
                    </li>
                  </ul>
                </div>
                <div className='copy-right'>
                  <span dangerouslySetInnerHTML={{ __html: copyRightText }} />
                </div>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Draggable>
  );
};
export default AboutPopup;
